import { WebviewTenant } from "@enums/webview-tenant";

export const TenantActionValue = {
    [WebviewTenant.AIRPASS]: {
        background_color: '#1E1E1E',
        back_button_color: '#FFFFFF',
        is_appbar_transparent: false,
        ignore_safe_area: false,
        show_back_button: true,
        status_icon_brightness: "light"
    }
}

// ALIND

export const TenantPageConfig: any = {
    [WebviewTenant.AIRPASS]: {
        FLIGHT_DASHBOARD: {
            action_value: {
                background_color: '#1E1E1E',
                back_button_color: '#FFFFFF',
                is_appbar_transparent: false,
                ignore_safe_area: false,
                show_back_button: true,
                title: "Flight Details",
                title_color: "#FFFFFF",
                status_icon_brightness: "light"
            },
            top_margin_value: 0
        },
        FLIGHT__BOOKING_DASHBOARD: {
            action_value: {
                background_color: '#1E1E1E',
                back_button_color: '#FFFFFF',
                is_appbar_transparent: false,
                ignore_safe_area: false,
                show_back_button: true,
                title: "All available flights",
                title_color: "#FFFFFF",
                status_icon_brightness: "light"
            },
            top_margin_value: 0
        },
        LANDING_PAGE: {
            action_value: {
                background_color: '#1E1E1E',
                back_button_color: '#FFFFFF',
                is_appbar_transparent: true,
                ignore_safe_area: false,
                show_back_button: true,
                status_icon_brightness: "light",
                ignore_blur: false,
            },
            is_top_margin_required: true
        },
    }

}